_ = require('underscore')

module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  props:
    id:       { default: null }
    value:    { default: null }
    label:    { default: null }
    error:    { default: null }
    required: { default: false }

  computed:

    hasLabel: ->
      _.isString(@label) && _.size(@label) > 0

    hasError: ->
      _.isString(@error) && _.size(@error) > 0

    isRequired: ->
      @required == true || @required == 'true'




// WEBPACK FOOTER //
// ./assets/js/frontend/components/form/abstract/index.coffee